var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"progress-loading"},[_c('img',{staticClass:"progress-loading__img",attrs:{"src":"/img/loading.gif","alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }